export const logInUser = (response, history, setUser, setLoading = () => {}) => {
  if (response?.success) {
    setUser(response.data)
    localStorage.setItem('user', JSON.stringify({
      email: response.data?.email,
      accessToken: response.data?.accessToken,
      refreshToken: response.data?.refreshToken,
    }))

    if (history.location?.pathname?.indexOf('/home') !== 0) {
      history.push('/home')
    }
  } else {
    console.warn(response)
  }
  setLoading(false)
}
